import React, { useEffect } from 'react';

import { kcGateway } from '../../utils/keycloak';

export const NEXT_URL_STORAGE_KEY = 'nextUrl';

const RenewCallbackPage = () => {
  useEffect(() => {
    kcGateway.signInSilentCallback().catch(() => {
      console.error('Silent renew failed');
    });
  }, []);

  return <div />;
};

export default RenewCallbackPage;
